import { useCallback, useState } from 'react';
import axios from 'Axios';
import Countdown from 'react-cntdwn';
import { api, toastify } from 'Utils';
import { ModalBox, Button, FieldMessage } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxForget = ({
	isOpen,
	onClose,
	size,
	onToggleLogin,
	onTogglePassword
}) => {
	const initialState = () => ({
		fields: {
			mobile: '',
			code: ''
		},
		getNewCode: true,
		isWaitingCode: false,
		isSubmiting: false,
		errors: {}
	});

	const [state, setState] = useState(initialState());

	const resetState = useCallback(() => {
		setState(initialState());
	}, []);

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const onFinishCountdown = () => {
		setState((prev) => ({
			...prev,
			getNewCode: true
		}));
	};

	const resendCode = () => {
		if (!state.fields.mobile) {
			// return toastify('');
			setState((prev) => ({
				...prev,
				errors: { mobile: 'شماره همراه الزامی است' }
			}));
			return false;
		}
		setState((prev) => ({
			...prev,
			isWaitingCode: true
		}));
		// console.log('state.fields.mobile: ', state.fields.mobile);
		const data = {
			mobile: state.fields.mobile
		};
		axios.post(api.sendSms, data).then((res) => {
			if (res.status === 200) {
				let data = res.data;
				if (data.success) {
					setState((prev) => ({
						...prev,
						getNewCode: false
					}));
					toastify(data.message, 'info');
				}
				setState((prev) => ({
					...prev,
					isWaitingCode: false
				}));
			} else {
				toastify('خطا در برقراری ارتباط با سرور');
			}
		});
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.mobile) {
			formIsValid = false;
			errors['mobile'] = 'شماره همراه خود را وارد کنید';
		}
		if (!fields.code) {
			formIsValid = false;
			errors['code'] = 'کد تایید را وارد کنید';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const data = state.fields;
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));
			sessionStorage.setItem('mobile', data.mobile);
			axios.post(api.mobileVerification, data).then((res) => {
				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				const data = res.data;
				if (data.code === 200) {
					if (data.success) {
						onTogglePassword?.();
					} else {
						toastify('کد تایید موبایل معتبر نمی باشد');
					}
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	let targetDate = new Date();
	targetDate.setMinutes(targetDate.getMinutes() + 1);

	return (
		<ModalBox
			isOpen={isOpen}
			size={size}
			onClose={onClose}
			onDestroy={resetState}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>فراموشی کلمه عبور</h3>
			</header>
			<div className={styles.body}>
				<form className={styles.form} onSubmit={handleSubmit}>
					<div className={styles.fieldset}>
						<label htmlFor="mobile" className={styles.label}>
							شماره همراه
						</label>
						<div className={styles.fieldBox}>
							<input
								id="mobile"
								name="mobile"
								type="tel"
								inputMode="tel"
								className={[
									styles.input,
									styles.input_ltr
								].join(' ')}
								onChange={handleInput}
							/>
							<div className={styles.resend}>
								{!state.getNewCode && (
									<Countdown
										format={{
											minute: 'mm',
											second: 'ss'
										}}
										targetDate={targetDate}
										interval={1000}
										timeSeparator={':'}
										leadingZero
										onFinished={onFinishCountdown}
									/>
								)}
								{state.getNewCode && (
									<Button
										className={styles.btnBorder}
										disabled={state.isWaitingCode}
										onClick={resendCode}>
										{state.isWaitingCode
											? '...'
											: 'دریافت کد تایید'}
									</Button>
								)}
							</div>
						</div>
						{state.errors.mobile && (
							<FieldMessage text={state.errors.mobile} />
						)}
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="code" className={styles.label}>
							کد تایید موبایل
						</label>
						<input
							id="code"
							name="code"
							type="text"
							autoComplete="one-time-code"
							inputMode="numeric"
							className={[styles.input, styles.inputSpacing].join(
								' '
							)}
							onChange={handleInput}
						/>
						{state.errors.code && (
							<FieldMessage text={state.errors.code} />
						)}
					</div>
					<div className={styles.fieldset}>
						<Button
							className={styles.submit}
							disabled={state.isSubmiting}
							type="submit">
							ارسال کد تایید
						</Button>
					</div>
					<div className={styles.fieldset}>
						<p className={styles.text}>
							<Button
								className={styles.textLink}
								onClick={onToggleLogin}>
								ورود به سایت
							</Button>
						</p>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
